import { Component, inject, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { IRegisteredAddress, RegisteredAddress } from '../../../../../../models/registered-address.model';
import { OptionsTypeSelector } from '../../../../../../models/options-type-selector';
import { CIVILITIES_OPTIONS } from '../../../../../../models/enums/civilities-option.enum';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { User } from '../../../../../../models/user.model';
import { RegisteredAddressFormGroup } from '../../../../../../models/forms/RegisteredAddressFormGroup';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';
import { AddressTypeEnum } from '../../../../../../models/enums/address-type.enum';
import { AddressCardOptions } from '../../../../ui/cards/address-card/address-card-options.model';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  templateUrl: './bary-modal-add-or-update-address.component.html',
  styleUrls: ['./bary-modal-add-or-update-address.component.scss'],
})
export class BaryModalAddOrUpdateAddressComponent extends BaryModalForm implements OnInit {
  readonly #modalRef = inject(MDBModalRef);
  readonly #bcf = inject(BaryFormFactoryService);

  override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  override model: IRegisteredAddress = new RegisteredAddress();

  public formGroup!: RegisteredAddressFormGroup;
  public user!: User;
  public step = 1;
  public addOrUpdate = 'add';
  public options: AddressCardOptions = {
    withAdditional: true,
    withAutoFill: true,
    withFullName: true,
    withFloorNumber: false,
    withAddressNotFoundForm: true,
    rowsForAdditional: 3,
  };
  public _addressTypeSelector = OptionsTypeSelector.ADDRESS_TYPE;
  public _civilitiesOptions = CIVILITIES_OPTIONS;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    this.user = (this.model.pickupUser ?? this.model.deliveryUser)!;
    this.formGroup = this.#bcf.makeRegisteredAddressForm(this.user, this.model);

    if (!this.formGroup.controls.loadingConstraint.value) {
      this.formGroup.controls.loadingConstraint.setValue(OptionsTypeSelector.LOADING_CONSTRAINT[0].value);
    }

    if (!this.formGroup.controls.accessConstraint.value) {
      this.formGroup.controls.accessConstraint.setValue(OptionsTypeSelector.ACCESS_CONSTRAINT[0].value);
    }
  }

  public handleClick(from: any): void {
    if (from.next) {
      let valid = true;
      switch (this.step) {
        case 1: {
          valid = valid && this.formGroup.controls.address.getAngularForm().valid && this.formGroup.controls.contact.getAngularForm().valid;
          break;
        }
        case 2: {
          valid = valid && this.formGroup.controls.loadingConstraint.valid && this.formGroup.controls.accessConstraint.valid;
          break;
        }
        case 3: {
          valid = valid && this.formGroup.controls.alias.valid;
          break;
        }
      }

      if (!valid) {
        this.formGroup.getAngularForm().markAllAsTouched();
        this.focusOnFirstError();
      } else {
        this.step = from.value;
      }
    } else if (from.back) {
      this.step = from.value;
    } else if (from.close || from.cancel) {
      this.action.next(new BaryModalEvent(from));
      this.#modalRef.hide();
    } else {
      console.warn('No valid action for handleClick ' + from);
    }
  }

  override handleSubmit(from: any): void {
    if (this.formGroup.getAngularForm().invalid) {
      this.formGroup.getAngularForm().markAllAsTouched();
      this.focusOnFirstError();
    } else {
      this.submit(from);
    }
  }

  override submit(from: any): void {
    this.formGroup.updateModel(this.model);
    from.value = this.model;
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  public isPickup(): boolean {
    return this.formGroup.controls.addressType.value === AddressTypeEnum.PICKUP || this.formGroup.controls.addressType.value === AddressTypeEnum.BOTH;
  }
}
